import { createContext, useContext, useEffect, useState } from 'react';
import { subscribe } from '../services/utils/pubsub';
import { events } from '../services/wss/SystemEvents';
import userEngine from '../controllers/User/UserEngine';

const UserContext = createContext(null);

/**
 * Provides the authenticated user object to the component tree.
 * Populated via pubsub onUserLoaded — fired by UserEngine after SignalR auth completes.
 * Initial value is taken from userEngine cache in case provider mounts after onUserLoaded fired.
 */
export function UserProvider({ children }) {
    const [user, setUser] = useState(() => userEngine.getUser());

    useEffect(() => {
        return subscribe(events.onUserLoaded, (u) => setUser(u));
    }, []);

    return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
}

/**
 * Returns the authenticated user object, or null if not yet loaded.
 * @returns {object|null}
 */
export function useUser() {
    const ctx = useContext(UserContext);
    if (ctx === undefined) throw new Error('useUser must be used within UserProvider');
    return ctx;
}

export default UserContext;
